import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* cascaderLoadOption(action) {
  const {
    data: { location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/cascader/load-option`,
      { location_visibility },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    yield put(actions.cascaderLoadOption.success(res.data))
  } catch (err) {
    console.log(err)
    yield put(actions.cascaderLoadOption.failure())
  }
}

function* cascaderLoadDivision(action) {
  const {
    data: {
      division_id,
      section_id,
      department_id,
      plant_id,
      location_visibility,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/cascader/load-division`,
      {
        division_id,
        section_id,
        department_id,
        plant_id,
        location_visibility,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    yield put(actions.cascaderLoadDivision.success(res.data))
  } catch (err) {
    console.log(err)
    yield put(actions.cascaderLoadDivision.failure())
  }
}

function* cascaderLoadDepartment(action) {
  const {
    data: { division_id, location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/cascader/load-department`,
      {
        division_id,
        location_visibility,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    yield put(actions.cascaderLoadDepartment.success(res.data))
  } catch (err) {
    console.log(err)
    yield put(actions.cascaderLoadDepartment.failure())
  }
}

function* cascaderLoadSection(action) {
  const {
    data: { division_id, department_id, location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/cascader/load-section`,
      {
        division_id,
        department_id,
        location_visibility,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    yield put(actions.cascaderLoadSection.success(res.data))
  } catch (err) {
    console.log(err)
    yield put(actions.cascaderLoadSection.failure())
  }
}

function* cascaderLoadPlant(action) {
  const {
    data: {
      division_id,
      department_id,
      section_id,
      location_visibility,
      accessToken,
    },
    requestId,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/cascader/load-plant`,
      {
        division_id,
        department_id,
        section_id,
        location_visibility,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    yield put(actions.cascaderLoadPlant.success(res.data, requestId))
  } catch (err) {
    console.log(err)
    yield put(actions.cascaderLoadPlant.failure(requestId))
  }
}

export default function* watchCascader() {
  yield all([
    takeEvery(actions.CASCADER_DIVISION.REQUEST, cascaderLoadDivision),
    takeEvery(actions.CASCADER_DEPARTMENT.REQUEST, cascaderLoadDepartment),
    takeEvery(actions.CASCADER_SECTION.REQUEST, cascaderLoadSection),
    takeEvery(actions.CASCADER_PLANT.REQUEST, cascaderLoadPlant),
    takeEvery(actions.CASCADER_OPTION.REQUEST, cascaderLoadOption),
  ])
}
